import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import AppContext from "../AppContext";
import logo from '../assets/img/logo.png'
import RequireSubscription from "../pages/RequireSubscription";

export const PrivateRoute = ({ requireSubscription, demoRestricted, children }) => {
    const app = useContext(AppContext);
    const { pathname } = useLocation(); // this will only work if you wrap your App component in a Router
    const [loggedIn, setLoggedIn] = useState(-1)

    useMemo(() => {
        const getMe = async () => {
            setLoggedIn(-1)
            const me = await app.refreshMe()
            if(me) {
                setLoggedIn(1)
            }
            else
                setLoggedIn(0)
        }
        // if(loggedIn === -1) {
        //     getMe()
        // }
        getMe()
    }, [pathname])

    if(loggedIn === -1) {
        return <div className="page-loading-overlay">
            <div><img src={logo} alt="" /></div>
        </div>
    }

    if (loggedIn) {
        if(demoRestricted && app.user?.demo) {
            return <Navigate to="/demo" />
        }

        if(requireSubscription) {
            const subs = app.user.subscriptions;

            let sub = false;
            switch (app.user.current_course) {
                case 1:
                    sub = subs?.bth;
                    break;
                case 2:
                    sub = subs?.ath;
                    break;
                case 3:
                    sub = subs?.amth;
                    break;
            }

            if((!sub || sub.active <= 0) && !app.user?.demo)
                return <RequireSubscription />
        }
        return children
    }

    return <Navigate to="/login" />
}
export default PrivateRoute